import React, { useState, useEffect } from "react";
import "./Mid-section-Pc.scss"; // CSS file for custom styles

//components

import QuickLinksCard from "../Mobile-and-Tablet/QuickLinksCard";

//icons
import { FaHome } from "react-icons/fa";
import { MdWaterDrop } from "react-icons/md";
import { FaClock } from "react-icons/fa";
import { FaSpinner } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { LiaFileInvoiceSolid } from "react-icons/lia";

//components
import TransactionsTable from "./Payments-Table";
import InformationCardPc from "./Information-Card-Pc";
import PaymentModal from "../../PaymentModal";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import { getProfile } from "../../../../redux/slices/sliceActions";

const MiddleSectionPc = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);

  useEffect(() => {
    console.log("user data in mid section pc", user);
  }, [user]);
  const token = user?.data?.accessToken;
  const id = user?.data?.user?.user_id;

  const [profileUpdated, setProfileUpdated] = useState(false);
  const [latestInvoice, setLatestInvoice] = useState([]);
  const [paymentProgress, setPaymentProgress] = useState([]);

  const [defaultValues, setDefaultValues] = useState({
    rent: latestInvoice?.rent || "0",
    water: latestInvoice?.water || "0",
    arrears: latestInvoice?.arrears || "0",
    serviceCharge: latestInvoice?.service_charge || "0",
    unpaidDeposit: latestInvoice?.unpaid_deposit || "0",
    garbage: latestInvoice?.garbage || "0",
    paymentMethod: latestInvoice?.paymentMethod || "PAYBILL",
    phoneNumber: latestInvoice?.phoneNumber || "",
    referenceNumber: latestInvoice?.referenceNumber || "",
    month: latestInvoice?.month || "",
    year: latestInvoice?.year || "",
    paymentNarration: latestInvoice?.paymentNarration || "",
  });

  useEffect(() => {
    if (!id) return;
    console.log("here is the id", user?.data?.user?.user_name);
    dispatch(getProfile({ userId: id })).then((res) => {
      console.log("profile update", res);
      setProfileUpdated(true);
      setPaymentProgress(res?.payload?.data?.tenant_details?.payments);
      setLatestInvoice(res?.payload?.data?.tenant_details?.unpaidInvoices);
      //set month and year in default values
    });
  }, [id]);

  useEffect(() => {
    if (latestInvoice?.month) {
      setDefaultValues({
        ...latestInvoice,
        month: latestInvoice?.month,
        year: latestInvoice?.year,
      });
    }
  }, [latestInvoice]);

  const [seeMoreClicked, setSeeMoreClicked] = useState(false);
  const [seeMoreQuickLinksClicked, setSeeMoreQuickLinksClicked] =
    useState(false);

  const cardData1 = {
    Title: "Invoices Pending",
    rent: latestInvoice?.rent || "0",
    water: latestInvoice?.water || "0",
    arrears: latestInvoice?.arrears || "0",
    // serviceCharge: latestInvoice?.service_charge || "0",
    // unpaidDeposit: latestInvoice?.unpaid_deposit || "0",
    garbage: latestInvoice?.garbage || "0",
    totalAmount:
      (latestInvoice?.rent || 0) +
      (latestInvoice?.water || 0) +
      (latestInvoice?.arrears || 0) +
      // (latestInvoice?.service_charge || 0) +
      // (latestInvoice?.unpaid_deposit || 0) +
      (latestInvoice?.garbage || 0),
  };

  const cardData2 = {
    Title: "Invoices Paid",
    rent: paymentProgress?.rent || "0",
    water: paymentProgress?.water || "0",
    arrears: paymentProgress?.arrears || "0",
    serviceCharge: paymentProgress?.serviceCharge || "0",
    unpaidDeposit: paymentProgress?.unpaidDeposit || "0",
    garbage: paymentProgress?.garbage || "0",
    totalAmount:
      (paymentProgress?.rent || 0) +
      (paymentProgress?.water || 0) +
      (paymentProgress?.arrears || 0) +
      // (paymentProgress?.serviceCharge || 0) +
      // (paymentProgress?.unpaidDeposit || 0) +
      (paymentProgress?.garbage || 0),
  };
  const cardData3 = {
    Title: "Arrears",
    rent: cardData1.rent,
    water: cardData1.water,
    arrears: cardData1.arrears,
    serviceCharge: cardData1.serviceCharge,
    unpaidDeposit: cardData1.unpaidDeposit,
    garbage: cardData1.garbage,
    totalAmount:
      (cardData1.rent || 0) +
      (cardData1.water || 0) +
      (cardData1.arrears || 0) +
      (cardData1.serviceCharge || 0) +
      (cardData1.unpaidDeposit || 0) +
      (cardData1.garbage || 0),
  };

  //modal
  const [isOpen, setIsOpen] = useState(false);
  const [fieldsToShow, setFieldsToShow] = useState([]);
  const closeModal = () => {
    setIsOpen(false);
    setFieldsToShow([]);
  };
  const openModal = (fieldsToShow) => {
    setFieldsToShow(fieldsToShow);
    //switch case to set the default values
    switch (fieldsToShow[0]) {
      case "rent":
        setDefaultValues({
          ...defaultValues,
          rent: latestInvoice?.rent || "0",
        });
        // defaultValues.rent = latestInvoice?.rent || "0";

        break;
      case "water":
        setDefaultValues({
          ...defaultValues,
          water: latestInvoice?.water || "0",
        });

        // defaultValues.water = latestInvoice?.water || "0";
        break;
      case "Arrears":
        setDefaultValues({
          ...defaultValues,
          arrears: latestInvoice?.arrears || "0",
        });

        // defaultValues.arrears = latestInvoice?.arrears || "0";
        break;
      case "Service Charge":
        setDefaultValues({
          ...defaultValues,
          serviceCharge: latestInvoice?.service_charge || "0",
        });
        // defaultValues.serviceCharge = latestInvoice?.service_charge || "0";
        break;
      case "Unpaid Deposit":
        setDefaultValues({
          ...defaultValues,
          unpaidDeposit: latestInvoice?.unpaid_deposit || "0",
        });
        // defaultValues.unpaidDeposit = latestInvoice?.unpaid_deposit || "0";
        break;
      case "Garbage":
        setDefaultValues({
          ...defaultValues,
          garbage: latestInvoice?.garbage || "0",
        });
        // defaultValues.garbage = latestInvoice?.garbage || "0";
        break;
      default:
        break;
    }

    console.log(fieldsToShow);
    setIsOpen(true);
  };

  return (
    <div className="mid-section-pc">
      <div className="title-container">
        <div className="greeting">Hello {user?.data?.user?.user_name}</div>
        <div className="title">Reports</div>
        {/* <button className="more" onClick={() => {
          setSeeMoreClicked(!seeMoreClicked);
        }}>
          {seeMoreClicked ? "Hide" : "See more"}
        </button> */}
      </div>
      <div className="cards-container">
        <InformationCardPc Title={"Invoices Pending"} />
        <InformationCardPc Title={"Invoices Paid"} />
        <InformationCardPc Title={"Arrears"} />
      </div>

      <div className="quick-links-container">
        <div className="title-container">
          <div className="title">Make Quick Payments</div>
          {/* <button className="more" onClick={() => {
          setSeeMoreQuickLinksClicked(!seeMoreQuickLinksClicked);
        }}>See more</button> */}
        </div>

        <div className="quick-links-card-container">
          <QuickLinksCard
            title={"Rent"}
            Icon={FaHome}
            openModal={openModal}
            closeModal={closeModal}
          />
          <QuickLinksCard
            title={"Water"}
            Icon={MdWaterDrop}
            openModal={openModal}
            closeModal={closeModal}
          />
          <QuickLinksCard
            title={"Arrears"}
            Icon={FaClock}
            openModal={openModal}
            closeModal={closeModal}
          />
          <QuickLinksCard
            setMarginTop={true}
            title={"Service Charge"}
            Icon={LiaFileInvoiceSolid}
            openModal={openModal}
            closeModal={closeModal}
          />
          <QuickLinksCard
            setMarginTop={true}
            title={"Unpaid Deposit"}
            Icon={FaSpinner}
            openModal={openModal}
            closeModal={closeModal}
          />
          <QuickLinksCard
            setMarginTop={true}
            title={"Garbage"}
            Icon={FaTrash}
            openModal={openModal}
            closeModal={closeModal}
          />
        </div>
      </div>
      <div className="transactions-container">
        <div className="title-container" style={{ marginBottom: "0px" }}>
          <div className="title">Latest Transactions</div>
        </div>
        <TransactionsTable />
      </div>

      <PaymentModal
        isOpen={isOpen}
        closeModal={closeModal}
        defaultValues={defaultValues} // Set default values here
        fieldsToShow={fieldsToShow} // Specify which fields to show
      />
    </div>
  );
};

export default MiddleSectionPc;
